'use client';
import { ProductCarousel } from '@eliadmin/core/src/components/product/product-carousel';
import { Container } from '@eliadmin/core/src/components/ui/container';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useRelatedProducts } from '@eliadmin/core/src/hooks/products/use-related-products';
import { RelatedProductsStatus } from '@eliadmin/core/src/components/product/detail/related-products-status';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
export function ProductRelatedProducts({ slug }: { slug: string }) {
  const { t } = useTranslations();
  const related = useRelatedProducts(slug);
  const products = related.products;
  if (!products.length && !related.isLoading && !related.isError) return null;
  return (
    <>
      {' '}
      {products.length > 0 && (
        <section className={cn('custom-section')}>
          <Container className={cn('flex flex-col space-y-2 pb-2', 'ea-product-related')}>
            <h3 className={cn('text-2xl font-bold', 'ea-product-related__title')}>{t('text60')}</h3>
            <ProductCarousel products={products} />
          </Container>
        </section>
      )}{' '}
      <div className="mx-auto w-full max-w-screen-2xl px-4">
        <RelatedProductsStatus
          loading={related.isLoading}
          error={related.isError}
          retry={() => {
            void related.refetch();
          }}
        />
      </div>{' '}
    </>
  );
}
